import { GitPushNonDbtPayload } from './models/non-dbt.model';

export interface ErrorResponse<TBody extends object = object> {
  body: TBody;
  code: number;
  dbt: boolean;
}

export async function createErrorResponse(payload: string): Promise<ErrorResponse | null> {
  const dbt = payload.includes('Y42-RESPONSE-BODY');
  const pushError = dbt ? parseDbtPayload(payload) : parseNonDbtPayload(payload);
  return pushError
    ? {
        ...pushError,
        dbt,
      }
    : null;
}

function parseDbtPayload(payload: string): { body: object; code: number } | null {
  const bodyString = payload.match(/^Y42-RESPONSE-BODY:\s*(?<response>.*)$/m)?.groups?.['response'];
  const codeString = payload.match(/^Y42-RESPONSE-CODE:\s*(?<response>.*)$/m)?.groups?.['response'];

  if (!bodyString || !codeString) {
    // Malformed Y42-RESPONSE-BODY or Y42-RESPONSE-CODE
    return null;
  }

  return {
    body: JSON.parse(bodyString),
    code: parseInt(codeString),
  };
}

function parseNonDbtPayload(payload: string): { body: object; code: number } | null {
  const descriptionDelimiter = '] description: ';
  const y42HookErrorDelimiter = 'Y42-HOOK-ERR';

  // Parse first json object
  const startIndex = payload.indexOf(descriptionDelimiter);

  let jsonString = payload.slice(startIndex + descriptionDelimiter.length);
  const stopIndex = jsonString.indexOf(y42HookErrorDelimiter);
  jsonString = jsonString.slice(0, stopIndex);

  let wrapperErrorResponse: { message: string; statusCode: number };
  let errorResponse: GitPushNonDbtPayload;

  try {
    wrapperErrorResponse = JSON.parse(jsonString);
    errorResponse = JSON.parse(wrapperErrorResponse.message);
  } catch {
    return null;
  }

  return {
    body: errorResponse,
    code: wrapperErrorResponse.statusCode,
  };
}
